import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import React from 'react'
import { useStyles } from './style'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

export default ({ value, onChange }) => {
  const classes = useStyles()

  const handleChange = React.useCallback(date => {
    if (!date || isNaN(date.valueOf())) return
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    onChange(date.toISOString())
  }, [onChange])

  // format the label string using the browsers default format to match the list date column
  const handleLabel = React.useCallback(date => date ? date.toLocaleDateString() : '', [])

  const parsedValue = typeof value === 'string' ? new Date(value) : value

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        id='last-updated-picker'
        autoOk
        disableFuture
        disableToolbar
        orientation='landscape'
        inputVariant='outlined'
        format='dd/MM/yyyy'
        slotProps={{
          textField: { size: 'small', InputLabelProps: { size: 'small' } }
        }}
        sx={{ maxWidth: 200, marginLeft: 2 }}
        margin='none'
        label='Updated since'
        labelFunc={handleLabel}
        value={parsedValue}
        onChange={handleChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
          classes: { root: classes.keyboardAdornment }
        }}
        InputProps={{
          classes: { adornedEnd: classes.dateFilterAdornedEnd }
        }}
        InputLabelProps={{
          classes: { root: classes.dateFilterLabel }
        }}
      />
    </LocalizationProvider>
  )
}
